import React, { ReactNode } from "react";
import { useField } from "formik";
import { CheckboxProps, FormControl, FormControlLabelProps } from "@mui/material";
import { CheckboxField, ValidationMessages } from "./index";

export interface CheckboxFormikProps
  extends Omit<CheckboxProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  status?: boolean;
}

const CheckboxFormik = ({
  name,
  label,
  value,
  labelPlacement,
  status,
  ...props
}: CheckboxFormikProps) => {
  const [field, meta, helpers] = useField(name);

  return (
    <FormControl error={meta.touched && Boolean(meta.error)} component="fieldset">
      <CheckboxField name={name} label={label} status={status} {...props} />
      <ValidationMessages meta={meta} />
    </FormControl>
  );
};

export default CheckboxFormik;